/* eslint-disable @typescript-eslint/no-unsafe-return */
import {createBrowserRouter, redirect} from 'react-router-dom';
import Root from './routes/Root';
import Error from './routes/Error';
import PrivateRoute from './routes/PrivateRoute';
import {lazy} from 'react';
import Async from '@components/Async/Async';
import TrackView from '@components/EventTracking/TrackView';
import AdminRoute from '@routes/AdminRoute';
import AdminRoot from '@routes/admin/AdminRoot/AdminRoot';

// prettier-ignore
const SignUp = lazy(async () => import(/* webpackChunkName: "signup" */ '@routes/SignUp'));
// prettier-ignore
const LogIn = lazy(async () => import(/* webpackChunkName: "login" */ '@routes/LogIn'));
// prettier-ignore
const ForgotPassword = lazy(async () => import(/* webpackChunkName: "forgot-password" */ '@routes/ForgotPassword'));
// prettier-ignore
const ForgotPasswordSet = lazy(async () => import(/* webpackChunkName: "forgot-password-set" */ '@routes/ForgotPasswordSet'));
// prettier-ignore
const VerifyEmail = lazy(async () => import(/* webpackChunkName: "verify-email" */ '@routes/VerifyEmail'));
// prettier-ignore
const Feedback = lazy(async () => import(/* webpackChunkName: "feedback" */ '@routes/Feedback/Feedback'));
// prettier-ignore
const Profile = lazy(async () => import(/* webpackChunkName: "profile" */ '@routes/Profile/Profile'));
// prettier-ignore
const Topup = lazy(async () => import(/* webpackChunkName: "topup" */ '@routes/Topup/Topup'));
// prettier-ignore
const AdminPromocodes = lazy(async () => import(/* webpackChunkName: "admin-promocodes" */ '@routes/admin/Promocodes/Promocodes'));
// prettier-ignore
const AdminEditPromocode = lazy(async () => import(/* webpackChunkName: "admin-edit-promocode" */ '@routes/admin/Promocode/EditPromocode'));
// prettier-ignore
const AdminNewPromocode = lazy(async () => import(/* webpackChunkName: "admin-new-promocode" */ '@routes/admin/Promocode/NewPromocode'));
// prettier-ignore
const AdminUsers = lazy(async () => import(/* webpackChunkName: "admin-users" */ '@routes/admin/Users/Users'));
// prettier-ignore
const AdminUserDetails = lazy(async () => import(/* webpackChunkName: "admin-user-details" */ '@routes/admin/User/UserDetails'));

export default createBrowserRouter([
    {
        path: '/',
        element: (
            <TrackView>
                <PrivateRoute>
                    <Root />
                </PrivateRoute>
            </TrackView>
        ),
        errorElement: <Error />,
        children: [
            {
                index: true,
                loader: () => redirect('/feedback'),
            },
            {
                path: '/profile',
                element: (
                    <Async>
                        <Profile />
                    </Async>
                ),
            },
            {
                path: '/topup',
                element: (
                    <Async>
                        <Topup />
                    </Async>
                ),
            },
            {
                path: '/feedback',
                element: (
                    <Async>
                        <Feedback />
                    </Async>
                ),
            },
            {
                path: '/scene',
                loader: () => redirect('/feedback'),
            },
            {
                path: '/synopsis',
                loader: () => redirect('/feedback'),
            },
            {
                path: '/short',
                loader: () => redirect('/feedback'),
            },
            {
                path: '/screenplay',
                loader: () => redirect('/feedback'),
            },
        ],
    },
    {
        path: '/admin',
        element: (
            <TrackView>
                <AdminRoute>
                    <AdminRoot />
                </AdminRoute>
            </TrackView>
        ),
        errorElement: <Error />,
        children: [
            {
                index: true,
                loader: () => redirect('/admin/promocodes'),
            },
            {
                path: '/admin/users',
                element: (
                    <Async>
                        <AdminUsers />
                    </Async>
                ),
            },
            {
                path: '/admin/users/:id',
                element: (
                    <Async>
                        <AdminUserDetails />
                    </Async>
                ),
            },
            {
                path: '/admin/promocodes',
                element: (
                    <Async>
                        <AdminPromocodes />
                    </Async>
                ),
            },
            {
                path: '/admin/promocodes/:id',
                element: (
                    <Async>
                        <AdminEditPromocode />
                    </Async>
                ),
            },
            {
                path: '/admin/promocodes/create',
                element: (
                    <Async>
                        <AdminNewPromocode />
                    </Async>
                ),
            },
        ],
    },
    {
        path: '/login',
        element: (
            <TrackView>
                <Async>
                    <LogIn />
                </Async>
            </TrackView>
        ),
        errorElement: <Error />,
    },
    {
        path: '/register',
        element: (
            <TrackView>
                <Async>
                    <SignUp />
                </Async>
            </TrackView>
        ),
        errorElement: <Error />,
    },
    {
        path: '/forgot-password',
        element: (
            <TrackView>
                <Async>
                    <ForgotPassword />
                </Async>
            </TrackView>
        ),
        errorElement: <Error />,
    },
    {
        path: '/forgot-password-set',
        element: (
            <TrackView>
                <Async>
                    <ForgotPasswordSet />
                </Async>
            </TrackView>
        ),
        errorElement: <Error />,
    },
    {
        path: '/verify',
        element: (
            <TrackView>
                <Async>
                    <VerifyEmail />
                </Async>
            </TrackView>
        ),
        errorElement: <Error />,
    },
]);
